import { createAction } from 'redux-actions';
export var createPollRequest = createAction('POLL.CREATE_REQUEST', function (payload) { return payload; });
export var createPollSuccess = createAction('POLL.CREATE_SUCCESS', function (payload) { return payload; });
export var updatePollRequest = createAction('POLL.UPDATE_REQUEST', function (payload) { return payload; });
export var updatePollSuccess = createAction('POLL.UPDATE_SUCCESS', function (payload) { return payload; });
export var requestFailure = createAction('POLL.REQUEST_FAILURE', function () { return ({}); });
//# sourceMappingURL=actions.js.map